import React, { Fragment, useRef, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash, faPenToSquare, faArrowAltCircleRight, faListAlt, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons'
import jsPDF from "jspdf";
import SolicitacaoService from "../../../../../services/solicitacao";
import cabeca from '../../../../../assets/images/cabeca.jpg'
import '../../../../../styles/balanco.scss'
import moment from "moment";
import 'moment/locale/pt-br';

const Solicitacao = (props) => {
    const [componentes, setComponentes] = useState([]);
    const [resp, setResp] = useState(false);
    const [showMemorandos, setShowMemorandos] = useState(false);
    const [listaMemorandos, setListaMemorandos] = useState([]);
    const pathName = window.location.pathname;

    async function fetchComps(id, path) {
        if (path === "/especificacoes/ti/solicitacao/respondidas") {
            setResp(true)
        }
        const response = await SolicitacaoService.verSolicitacao(id);
        if (response.data["componentes"].length >= 1) {
            setComponentes(response.data["componentes"]);
        } else {
            setComponentes([]);

        }
    }

    const verMemorandos = (solicitacao) => {
        if (!solicitacao.memorando || solicitacao.memorando.length === 0) {
            alert("Nenhum memorando encontrado.");
            return;
        }

        const ordenados = [...solicitacao.memorando].sort(
            (a, b) => new Date(b.data) - new Date(a.data)
        );

        setListaMemorandos(ordenados);
        setShowMemorandos(true);
    };

    useEffect(() => {
        fetchComps(props.solicitacao._id, pathName);
    }, []);

    moment.locale('pt-br');

    const printRef = useRef();
    const [pdfBlob, setPdfBlob] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [printData, setPrintData] = useState(null);

    const PAGE_WIDTH = 595.28;
    const PAGE_HEIGHT = 841.89;

    const MARGIN_X = 40;
    const HEADER_HEIGHT = 90;
    const FOOTER_HEIGHT = 60;

    const START_Y = HEADER_HEIGHT + 20;
    const MAX_Y = PAGE_HEIGHT - FOOTER_HEIGHT;

    const CONTENT_WIDTH = PAGE_WIDTH - MARGIN_X * 2;

    function ensureSpace(doc, currentY, requiredHeight = 20) {
        if (currentY + requiredHeight >= MAX_Y) {
            doc.addPage();
            return START_Y;
        }
        return currentY;
    }


    const gerarPDF = () => {
        const doc = new jsPDF({ unit: "pt", format: "a4" });


        let y = START_Y;

        /* ================= CABEÇALHO ================= */
        const addHeaderFooter = () => {
            doc.addImage(cabeca, "JPEG", MARGIN_X, 20, CONTENT_WIDTH, 60);

            doc.setFontSize(9);
            doc.text(
                "Rua Dr. Mário Freire Martins, 100, Centro – Macuco-RJ – Cep: 28.540-210 – Tel.: (22) 2554-9100 – email: dpto.ti@prefeituramacuco.rj.gov.br",
                PAGE_WIDTH / 2,
                PAGE_HEIGHT - 30,
                { align: "center" }
            );
        };

        addHeaderFooter();

        function writeFlowText(doc, text, startY) {
            const lines = doc.splitTextToSize(text, CONTENT_WIDTH);

            lines.forEach(line => {
                if (startY + 16 >= MAX_Y) {
                    doc.addPage();

                    // 🔑 CORREÇÃO CRÍTICA
                    doc.setFont(undefined, "normal");
                    doc.setFontSize(12);

                    startY = START_Y;
                }

                doc.text(line, MARGIN_X, startY);
                startY += 16;
            });

            return startY;
        }

        /* ================= TOPO ================= */
        doc.setFontSize(11);
        doc.text(
            `Especificação Técnica nº ${props.numeroPreview}`,
            MARGIN_X,
            y
        );

        doc.text(
            `Macuco, ${moment().format("DD [de] MMMM [de] YYYY")}`,
            PAGE_WIDTH - MARGIN_X,
            y,
            { align: "right" }
        );

        y += 30;

        /* ================= TEXTO FIXO ================= */
        const blocos = [
            `A ${props.solicitacao.secretaria}`,
            `A/C: ${props.solicitacao.responsavel}`,
            `Assunto: Especificação Técnica de Equipamentos e materiais de TIC.`,
            `Senhor(a) responsável,`,
            `Após análise do ambiente tecnológico da ${props.solicitacao.secretaria}, encaminhamos as especificações técnicas de todos os equipamentos e materiais de Tecnologia da Informação e Comunicação necessários para o bom funcionamento desta Secretaria.`
        ];

        doc.setFontSize(12);

        blocos.forEach(texto => {
            const linhas = doc.splitTextToSize(texto, CONTENT_WIDTH);
            y = ensureSpace(doc, y, linhas.length * 16);
            doc.text(linhas, MARGIN_X, y);
            y += linhas.length * 16 + 10;
        });

        /* ================= COMPONENTES ================= */
        componentes.forEach((item, index) => {
            doc.setFontSize(12);
            y = ensureSpace(doc, y, 80);

            doc.setFont(undefined, "bold");
            doc.text(`Item nº ${index + 1}`, MARGIN_X, y);
            y += 18;

            doc.text("Especificação Técnica:", MARGIN_X, y);
            y += 16;

            doc.setFont(undefined, "normal");

            const modelo = `Modelo de referência: ${item.componente.modeloReferencia}`;
            const modeloLinhas = doc.splitTextToSize(modelo, CONTENT_WIDTH);
            y = ensureSpace(doc, y, modeloLinhas.length * 16);
            doc.text(modeloLinhas, MARGIN_X, y);
            y += modeloLinhas.length * 16;

            const descricao = `${item.componente.categoria} com as seguintes especificações: ${item.componente.especificacaoTecnica}`;
            y = writeFlowText(doc, descricao, y);

            doc.setFont(undefined, "bold");
            doc.text(`Quantidade: ${item.qtd}`, MARGIN_X, y);
            y += 24;
            doc.setFont(undefined, "normal");
        });

        /* ================= RODAPÉ FINAL ================= */
        y = ensureSpace(doc, y, 80);
        doc.setFontSize(12);
        doc.text("Atenciosamente,", MARGIN_X, y);
        y += 90;
        doc.text("EDUARDO LEANDRO GIGLIO MONTEIRO", MARGIN_X, y);
        y += 16;

        doc.text("DIRETOR DO CTIC - MAT.: 4023", MARGIN_X, y);

        /* ================= REPETE CABEÇALHO/RODAPÉ ================= */
        const total = doc.getNumberOfPages();
        for (let i = 1; i <= total; i++) {
            doc.setPage(i);
            addHeaderFooter();
        }

        /* ================= SAÍDA ================= */
        const blob = doc.output("blob");
        window.open(URL.createObjectURL(blob), "_blank");
        setShowConfirm(true)
        setPdfBlob(blob)
    };


    useEffect(() => {
        if (!printData || !printRef.current) return;
        gerarPDF();
    }, [printData]);

    const fecharModal = () => {
        setShowConfirm(false);
        setPdfBlob(null);
    };

    const salvarPDF = async () => {
        if (!pdfBlob) return;

        setLoading(true);

        const formData = new FormData();
        formData.append(
            "arquivo",
            pdfBlob,
            `EspecificacaoTecnica_${props.numeroPreview}.pdf`
        );

        try {
            await SolicitacaoService.confirmaSolicitacao(
                props.solicitacao._id,
                formData
            );
            alert("Memorando salvo com sucesso!");
            fecharModal()
            props.fetchSolicitacoes()
        } catch (err) {
            alert("Erro ao salvar memorando");
        } finally {
            setLoading(false);
        }
    };

    const deletar = async (id) => {
        props.deletar(id)
    }

    const voltarPen = async (id) => {
        props.voltarPen(id)
    }

    const ver = async (id) => {
        props.ver(id)
    }
    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>
                <td onClick={() => navigator.clipboard.writeText(props.solicitacao._id)} data-label="Número da Solicitação">{props.solicitacao._id}</td>
                <td data-label="Secretaria">{props.solicitacao.secretaria}</td>
                <td data-label="Responsável">{props.solicitacao.responsavel}</td>
                <td data-label="Memorando">{props.solicitacao.numeroMemorando}</td>
                <td data-label="Data de Criação">
                    {moment(props.solicitacao.dataCriacao).format('DD/MM/YY')}
                </td>

                {/* ---- CÉLULAS PARA DESKTOP (cada ação tem seu td) ---- */}
                <td className="acoes-desktop-cell" title="Ver" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faEye}
                        className="mx-2 text-warning cursor-pointer"
                        onClick={() => ver(props.solicitacao._id)}
                    />
                </td>
                {resp ?
                    <Fragment>
                        <td className="acoes-desktop-cell" title="Ver Memorandos">
                            <FontAwesomeIcon
                                icon={faListAlt}
                                className="mx-2 text-warning cursor-pointer"
                                title="Ver Memorandos"
                                onClick={() => verMemorandos(props.solicitacao)}
                            />
                        </td>
                        <td className="acoes-desktop-cell" title="Voltar Memorando para Pendente">
                            <FontAwesomeIcon
                                icon={faArrowAltCircleLeft}
                                className="mx-2 text-warning cursor-pointer"
                                title="Voltar para Pendente"
                                onClick={() => voltarPen(props.solicitacao._id)}
                            />
                        </td>
                    </Fragment> :
                    <Fragment>
                        <td className="acoes-desktop-cell" title="Editar" style={{ whiteSpace: "nowrap" }}>
                            <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="mx-2 text-warning cursor-pointer"
                                onClick={() => editar(props.solicitacao._id)}
                            />
                        </td>
                        <td className="acoes-desktop-cell" title="Criar Memorando">
                            <FontAwesomeIcon
                                icon={faArrowAltCircleRight}
                                className="mx-2 text-warning cursor-pointer"
                                title="Criar Memorando"
                                onClick={() => gerarPDF(props.solicitacao, componentes, props.numeroPreview)}
                            />
                        </td>
                    </Fragment>
                }
                <td className="acoes-desktop-cell" title="Excluir" style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        onClick={() => deletar(props.solicitacao._id)}
                    />
                </td>

                {/* ---- CÉLULA EXTRA: GRID DE AÇÕES APENAS PARA MOBILE ----
                     Esta célula fica no DOM sempre, mas será escondida no desktop.
                     No mobile mostramos ela e escondemos as acoes-desktop-cell. */}
                <td className="acoes-mobile-cell">
                    <div className="acoes-mobile">
                        <div className="acao-item" onClick={() => ver(props.solicitacao._id)}>
                            <FontAwesomeIcon icon={faEye} className="acao-icon text-warning" />
                            <span>Ver</span>
                        </div>
                        <div className="acao-item" onClick={() => editar(props.solicitacao._id)}>
                            <FontAwesomeIcon icon={faPenToSquare} className="acao-icon text-warning" />
                            <span>Editar</span>
                        </div>
                        <div className="acao-item" onClick={() => deletar(props.solicitacao._id)}>
                            <FontAwesomeIcon icon={faTrash} className="acao-icon text-danger" />
                            <span>Excluir</span>
                        </div>
                    </div>
                </td>
            </tr>

            {/* Modal de confirmação */}
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Salvar memorando?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    O PDF foi gerado e aberto para visualização.
                    <br />
                    Deseja salvá-lo no sistema?
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowConfirm(false)}
                        disabled={loading}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="primary"
                        onClick={salvarPDF}
                        disabled={loading}
                    >
                        {loading ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
             {/* Modal de memorandos */}
            <Modal
                show={showMemorandos}
                onHide={() => setShowMemorandos(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Solicitações Técnicas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {listaMemorandos.map((mem, index) => (
                        <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded"
                        >
                            <div>
                                <strong>Especificação Técnica:</strong> {mem.numero}<br />
                                <small>
                                    Data: {moment(mem.data).format("DD/MM/YYYY HH:mm")}
                                </small>
                            </div>

                            <Button
                                variant="primary"
                                onClick={() =>
                                    window.open(mem.memorando, "_blank")
                                }
                            >
                                Visualizar PDF
                            </Button>
                        </div>
                    ))}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowMemorandos(false)}
                    >
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment >
    )
}

export default Solicitacao;
